import { ArrowLeftIcon } from "@heroicons/react/24/outline";

export default function PageHeader({ icon, title, onBack }) {
  return (
    <div className="h-16 px-4 md:px-8 flex items-center gap-3 justify-center border-b border-border-strong bg-surface-elevated sticky top-0 z-10">
      {/* Back button — positioned after the sidebar on desktop */}
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Go back"
          className="absolute left-4 md:left-[304px] lg:left-[336px] p-1.5 rounded-lg text-text-secondary hover:text-text-primary hover:bg-surface-muted transition-colors"
        >
          <ArrowLeftIcon className="h-5 w-5" />
        </button>
      )}
      {icon ?? icon}
      <span>
        <h2 className="text-xl font-semibold">{title}</h2>
      </span>
    </div>
  );
}
